import React, { useState } from 'react'

const withState = WrappedComponent => {
  return props => {
    const [form, setForm] = useState({ code: '' })
    const [formOpen, setFormOpen] = useState(false)

    return (
      <WrappedComponent
        form={form}
        setForm={setForm}
        formOpen={formOpen}
        setFormOpen={setFormOpen}
        {...props}
      />
    )
  }
}

export default withState
